module.exports = __webpack_public_path__ + "assets/img/thumb-Eimele-2-Landing-Page.70e27984.jpg";